import ApiClient from '@/api/client';

const path = require('path');

class FileDownloadAPI extends ApiClient {

  constructor() {
    super();
  }

  /** CREATE */
  async createFileDownloadFormat(data) {
    const response = await this.post(this.FILE_DOWNLOAD_API_APTH, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }


  /** UPDATE */
  async updateFileDownloadFormat(id, data) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `file-download/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async updateFileDownloadResource(resourceData, data, async = false) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `file-download/${resourceData.id}/`
    );
    const response = await this.patch(
      route,
      {
        href: resourceData.href,
        dataformat_id: resourceData.format.id
      }
    );
    const url2 = path.join(
      this.RESOURCE_API_PATH,
      `file-download/${resourceData.id}/?asynchrone=${async}`
    );
    const response2 = await this.patch(url2, data);
    if (response2.status === 200) {
      return response.data;
    }
    return false;
  }

  /** SCENARII */
  async getFileDownloadResourceScenarios(id) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `file-download/${id}/_scenarios/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async runFileDownloadResourceScenario(id, scenarioId, data) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `file-download/${id}/_scenarios/${scenarioId}/run/?asynchrone=true`
    );
    const response = await this.post(route, data);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }

  /** SCHEDULERS */
  async setFileDownloadScheduler(id, data) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `file-download/${id}/scenario-execution-frequency/`
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async updateFileDownloadScheduler(resourceId, data, scenarioId) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `file-download/${resourceId}/scenario-execution-frequency/${scenarioId}/`
    );
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async removeFileDownloadScheduler(resourceId, scenarioId) {
    const route = path.join(
      this.RESOURCE_API_PATH,
      `file-download/${resourceId}/scenario-execution-frequency/${scenarioId}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return true;
    }
    return false;
  }
}

const fileDownloadAPI = new FileDownloadAPI();
export default fileDownloadAPI;